import { Temporal } from '@imago/api-client'
import { sheets_v4 } from 'googleapis'
import type { KebabCasedProperties } from 'type-fest'
import { type GoogleInfo, parseSheet, toInstant } from './_google.ts'

export const GAHT_ONBOARDING_PAYMENT_DESCRIPTIONS = new Set(['Onboarding'])
export const GAHT_CARE_PAYMENT_DESCRIPTIONS = new Set(['Subscription creation', 'Subscription update', 'Payment for Invoice'])

export interface PaymentInfo {
	ID: string
	customerID: string | undefined
	patientID: string | undefined
	patientEmail: string | undefined
	created: Temporal.Instant
	amount: number
	currency: string
	description: string | undefined
	recordedCustomerID: string | undefined
	recordedEmail: string | undefined
}

export const PaymentRowFields: (keyof KebabCasedProperties<PaymentInfo>)[] = ['id', 'customer-id', 'patient-id', 'patient-email', 'created', 'amount', 'currency', 'description', 'recorded-customer-id', 'recorded-email']

function parsePaymentGInfo(row: GoogleInfo<KebabCasedProperties<PaymentInfo>>): PaymentInfo {
	return {
		ID: row['id'].stringValue,
		customerID: row['customer-id']?.stringValue,
		patientID: row['patient-id']?.stringValue,
		patientEmail: row['patient-email']?.stringValue,
		created: toInstant(row['created']),
		amount: row['amount'].numberValue,
		currency: row['currency'].stringValue,
		description: row['description']?.stringValue,
		recordedCustomerID: row['recorded-customer-id']?.stringValue,
		recordedEmail: row['recorded-email']?.stringValue,
	}
}

export function parsePaymentsGSheet(sheet: sheets_v4.Schema$Sheet) {
	return parseSheet(sheet, parsePaymentGInfo)
}
